export default {
    namespaced: true,
    state: {
        sets: [],
        errors: {
            getSets: {},
            setItemsToSet: {},
            createSet: {},
            removeItemsFromSet: {}
        }
    },
    mutations: {
        SET_SETS(state, payload) {
            state.sets = payload
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async getSets({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'getSets',
                val: {}
            })

            const url = '/supplier/sets'

            try {
                const resp = await this.$axios.get(url, { params: data })
                commit('SET_SETS', resp.data)
            } catch (e) {
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getSets',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getSets',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        },
        async setItemsToSet({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'setItemsToSet',
                val: {}
            })
            commit('SET_ERRORS', {
                key: 'createSet',
                val: {}
            })

            const url = '/supplier/item-set'

            try {
                const resp = await this.$axios.patch(url, data)
                return resp.data
            } catch (e) {
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'setItemsToSet',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'setItemsToSet',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        },
        async createSet({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'createSet',
                val: {}
            })
            commit('SET_ERRORS', {
                key: 'setItemsToSet',
                val: {}
            })

            const url = '/supplier/sets'

            try {
                const resp = await this.$axios.post(url, data)
                return resp.data
            } catch (e) {
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'createSet',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'createSet',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        },
        async removeItemsFromSet({ commit, dispatch }, data) {
            dispatch('resetErrors')

            const url = '/supplier/item-set'

            try {
                const resp = await this.$axios.delete(url, { data })
                return resp.data
            } catch (e) {
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'removeItemsFromSet',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'removeItemsFromSet',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        },
        resetErrors({ commit }) {
            commit('SET_ERRORS', {
                key: 'createSet',
                val: {}
            })
            commit('SET_ERRORS', {
                key: 'setItemsToSet',
                val: {}
            })
            commit('SET_ERRORS', {
                key: 'removeItemsFromSet',
                val: {}
            })
        }
    }
}
